import Cookies from "js-cookie";

const TokenKey = "tele2_vue_token";
const TokenRefreshKey = "tele2_vue_refresh_token";

export function getToken() {
  return Cookies.get(TokenKey);
}
export function getRefreshToken() {
  return Cookies.get(TokenRefreshKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(TokenRefreshKey, token);
}
export function removeRefreshToken() {
  return Cookies.remove(TokenRefreshKey);
}
